import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";


export default {
    methods: {
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
    }
}



// WEBPACK FOOTER //
// ./src/components/AdminDocs/AdminDocs.js